<div
    class="card"
    role="region"
    aria-labelledby="profileSupergroupHeader"
    *ngIf="user"
>
    <div
        class="card-header"
        id="profileSupergroupHeader"
        role="heading"
        aria-level="2"
    >
        {{ i18n._67_SUPERGROUP | translate }}
    </div>
    <div class="card-body">
        <cmps-wait-status *ngIf="hasPendingData"></cmps-wait-status>
        <div
            class="h6 text-center"
            *ngIf="
                !hasPendingData &&
                (!user.superGroups || !user.superGroups.length)
            "
        >
            {{ i18n._82_NO_SUPERGROUPS_CONFIGURED | translate }}
        </div>
        <div
            class="table-responsive"
            *ngIf="
                !hasPendingData && user.superGroups && user.superGroups.length
            "
        >
            <table
                class="table table-sm table-bordered-no-cells"
                aria-labelledby="profileSupergroupHeader"
            >
                <thead>
                    <tr>
                        <th>{{ i18n._53_NAME | translate }}</th>
                        <th>{{ i18n._75_START_DATE | translate }}</th>
                        <th>{{ i18n._73_END_DATE | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let i of user.superGroups">
                        <td>{{ i.userSuperGroupName }}</td>
                        <td>{{ i.startDate | date: 'y-MM-dd' }}</td>
                        <td>{{ i.endDate | date: 'y-MM-dd' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
